<div class="enhanced-staff-field-container">
  <!-- EDITABLE MODE -->
  <div *ngIf="canUpdate" class="editable-mode">
    <!-- Fixed Label with Modal Button -->
    <div class="staff-select-wrapper">
      <p class="staff-field-label">{{fieldLabel}}</p>
      <button
        type="button"
        class="staff-select-button"
        (click)="openSelectionModal()"
        [disabled]="!hasStaff"
        aria-label="Open staff selection">
        <span class="button-text" *ngIf="!hasSelections">Select staff</span>
        <span class="button-text" *ngIf="hasSelections">Change selection ({{selectedCount}})</span>
        <ion-icon name="chevron-forward-outline" class="button-icon"></ion-icon>
      </button>
    </div>

    <!-- Selected Items Preview (Chips with Avatars) -->
    <div class="staff-chips-container" *ngIf="hasSelections">
      <ion-chip
        *ngFor="let staff of getSelectedStaff()"
        class="staff-chip"
        [attr.aria-label]="'Remove ' + getStaffFullName(staff)">
        <div class="chip-avatar">{{getStaffInitials(staff)}}</div>
        <ion-label>{{getStaffFullName(staff)}}</ion-label>
        <ion-icon
          name="close-circle"
          (click)="removeStaff(staff.id)"
          class="chip-close-icon"></ion-icon>
      </ion-chip>

      <button
        type="button"
        class="btn-clear-all"
        (click)="clearAllStaff()"
        aria-label="Clear all staff">
        <ion-icon name="close-circle-outline"></ion-icon>
        Clear all
      </button>
    </div>

    <!-- Empty State (No Selections) -->
    <div class="staff-empty-state" *ngIf="!hasSelections">
      <ion-icon name="people-outline" class="empty-icon"></ion-icon>
      <p class="empty-text">No staff selected</p>
    </div>

    <!-- No Staff Available Warning -->
    <div class="staff-warning" *ngIf="!hasStaff">
      <ion-icon name="alert-circle-outline" class="warning-icon"></ion-icon>
      <p class="warning-text">No staff available for selection</p>
    </div>
  </div>

  <!-- READ-ONLY MODE -->
  <div *ngIf="!canUpdate" class="readonly-mode">
    <!-- Field Header -->
    <div class="field-header">
      <ion-icon name="people-outline" class="header-icon"></ion-icon>
      <span class="field-label">{{fieldLabel}}</span>
      <span class="count-badge" *ngIf="hasSelections">{{selectedCount}}</span>
    </div>

    <!-- Selected Staff as Pills -->
    <div class="staff-pills-grid" *ngIf="hasSelections">
      <span class="staff-pill" *ngFor="let staff of getSelectedStaff()">
        <div class="pill-avatar">{{getStaffInitials(staff)}}</div>
        <span class="pill-name">{{getStaffFullName(staff)}}</span>
      </span>
    </div>

    <!-- Empty State (No Selections) -->
    <div class="staff-empty-readonly" *ngIf="!hasSelections">
      <ion-icon name="people-outline" class="empty-icon-readonly"></ion-icon>
      <p class="empty-text-readonly">No staff assigned</p>
    </div>
  </div>
</div>
